'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageChannelsHelperService
 * @description A helper with methods that helps retrieving items from the Api calls responses
 */

angular.module('v-tv-package-services').service('TvPackageChannelsHelperService', function ChannelHelperService() {

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageChannelsHelperService#forEachMultiplex
     * @methodOf vTvPackageServices.TvPackageChannelsHelperService
     * @description Executes a callback function for each multiplex item found in each categories
     * @param {object} channelsByCategories List of categories, as returned by
     * {@link vTvPackageServices.TvPackageChannelsByCategories#getChannelsByCategories
     * TvPackageChannelsByCategories.getChannelsByCategories}
     * @param {function} cb function to call for each multiplex item
     */

    this.forEachMultiplex = function (channelsByCategories, cb) {
        for (var i = 0; i < channelsByCategories.length; i++) {
            for (var j = 0; j < channelsByCategories[i].displayElements.length; j++) {
                cb(channelsByCategories[i].displayElements[j]);
            }
        }
    };

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageChannelsHelperService#initChannelsCategories
     * @methodOf vTvPackageServices.TvPackageChannelsHelperService
     * @description Sets default extra values required on the channels object, under the attribute ```vm```
     * @param {object} channelsByCategories List of categories, as returned by
     * {@link vTvPackageServices.TvPackageChannelsByCategories#getChannelsByCategories
     * TvPackageChannelsByCategories.getChannelsByCategories}
     * @returns {object} Channels by categories
     */

    this.initChannelsCategories = function (channelsByCategories) {
        for (var i = 0; i < channelsByCategories.length; i++) {
            channelsByCategories[i].vm = {
                visibleChannelsCount: []
            };
        }

        return channelsByCategories;
    };

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageChannelsHelperService#indexChannelsCategoriesCharacteristics
     * @methodOf vTvPackageServices.TvPackageChannelsHelperService
     * @description For each multiplex, creates an index (hashmap) based on the characteristics keys and their values
     * @param {object} channelsByCategories List of categories, as returned by
     * {@link vTvPackageServices.TvPackageChannelsByCategories#getChannelsByCategories
     * TvPackageChannelsByCategories.getChannelsByCategories}
     * @returns {object} Channels by categories, with characteristics hashmap set on mplex.vm.characteristicsIndex
     */

    this.indexChannelsCategoriesCharacteristics = function (channelsByCategories) {
        var mplex = void 0;
        var category = void 0;

        for (var i = 0; i < channelsByCategories.length; i++) {
            category = channelsByCategories[i];

            for (var j = 0; j < category.displayElements.length; j++) {
                mplex = category.displayElements[j];
                mplex.vm = mplex.vm || {};
                mplex.vm.characteristicsIndex = {};

                for (var k = 0; k < mplex.characteristics.length; k++) {
                    mplex.vm.characteristicsIndex[mplex.characteristics[k].key] = mplex.characteristics[k].items;
                }
            }
        }

        return channelsByCategories;
    };

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageChannelsHelperService#indexChannelsByIds
     * @methodOf vTvPackageServices.TvPackageChannelsHelperService
     * @description For each multiplex, creates an index (hashmap) based on the mplex id and their content
     * @param {object} channelsByCategories List of categories, as returned by
     * {@link vTvPackageServices.TvPackageChannelsByCategories#getChannelsByCategories
     * TvPackageChannelsByCategories.getChannelsByCategories}
     * @returns {object} Hashmap of mplex id as the key and their objec as the value
     */

    this.indexChannelsByIds = function (channelsByCategories) {
        var mplexes = {};

        for (var categoriesLength = channelsByCategories.length, i = 0; i < categoriesLength; i++) {
            var category = channelsByCategories[i];

            for (var channelsLength = category.displayElements.length, j = 0; j < channelsLength; j++) {
                var mplex = category.displayElements[j];

                mplexes[mplex.id] = mplexes[mplex.id] || mplex;
            }
        }

        return mplexes;
    };
});